import { render, staticRenderFns } from "./objectionManagement.vue?vue&type=template&id=2bc33f0d&scoped=true"
import script from "./objectionManagement.vue?vue&type=script&lang=js"
export * from "./objectionManagement.vue?vue&type=script&lang=js"
import style0 from "./objectionManagement.vue?vue&type=style&index=0&id=2bc33f0d&prod&lang=less&scoped=true"
import style1 from "./objectionManagement.vue?vue&type=style&index=1&id=2bc33f0d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc33f0d",
  null
  
)

export default component.exports